export default __webpack_public_path__ + "static/media/Cryptyk.c26be6b5.png";